module.exports = __webpack_public_path__ + "static/media/inbox.ac2e5b31.png";